export default __webpack_public_path__ + "static/media/Ernst & Young.c4d0f7cf.png";